import React, { useEffect, useState } from "react";
import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import CloseIcon from "@material-ui/icons/Close";
import { useMaterialUIController } from "context";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { application } from "globals/endpoints";
import DataTable, { createTheme } from "react-data-table-component";
import colors from "assets/theme-dark/base/colors";
import MDTypography from "components/MDTypography";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import CTLNotification from "application/components/CTLNotification";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MDBox from "components/MDBox";
import TaskIcon from "@mui/icons-material/Task";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function TaskStatusUpdate({ row, onRefresh }) {
  const Id = row?.original?.id;
  const [open, setOpen] = React.useState(false);
  const [openTask, setOpenTask] = useState(false);
  const [formData, setformData] = useState({
    remarks: "",
  });
  const [controller] = useMaterialUIController();
  const darkModeContext = useMaterialUIController();
  const { darkMode } = controller;
  const [ViewData, setViewData] = useState([]);
  const currentStats = row?.original?.currentStats;
  const taskCompletedOn = row?.original?.taskCompletedOn;
  const taskName = row?.original?.tasksName;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const URL = {
    list: `/taskDetails/listAll/${Id}`,
    update: "task/update",
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function GetData() {
    application
      .post(URL.list)
      .then((res) => {
        setViewData(res.data.data);
      })
      .catch((error) => {
        console.log("error while the call /taskdetails/listAll", error);
      });
  }

  useEffect(() => {
    if (open) {
      GetData();
    } else {
      setViewData([]);
    }
  }, [open]);
  const username = AuthenticationService.getUserName();
  // Close Task
  function onUpdateStatus() {
    let data = {
      id:Id,
      currentStats: "Completed",
      tasksName: taskName,
      remarks: `Task Approved by ${username}`,
    };
    application
      .post(URL.update, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: "Task Management System",
        });
        onRefresh();
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: "Task Management System",
        });
      });
  }

  // ReOpen Task
  function onReOpenTask() {
    if (!formData.remarks || formData.remarks.trim() === "") {
      setNotify({
        isOpen: true,
        status:
          "Please provide remarks to explain why you are reopening the task",
        type: "warning",
        pagename: "Task Management System",
      });
      return;
    }
    let data = {
      id:Id,
      currentStats: "ReOpen",
      tasksName: taskName,
      remarks: formData.remarks,
    };
    application
      .post(URL.update, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: "Task Management System",
        });
        onRefresh();
        setOpenTask(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: "Task Management System",
        });
      });
  }

  const handleOpenTask = () => {
    setOpenTask(true);
  };
  const handleClosedTask = () => {
    setOpenTask(false);
  };
  createTheme(
    "modifiedDarkTheme",
    {
      striped: {
        default: colors.background.default,
      },
      selected: {
        default: colors.background.default,
      },
      background: {
        default: colors.background.card,
      },
    },
    "dark"
  );
  const header = [
    // {
    //   name: "taskId",
    //   selector: (row) => row?.taskId,
    //   sortable: true,
    // },
    {
      name: "Task Status",
      selector: (row) => row?.taskStats,
      sortable: true,
    },
    {
      name: "Status Updated By",
      selector: (row) => row?.statusUpdatedBy,
      sortable: true,
    },
    {
      name: "Status Updated On",
      selector: (row) => row?.statusUpdatedOn,
      sortable: true,
    },
    {
      name: "Is Delayed",
      selector: (row) => (row?.isDelay ? "True" : "False"),
      sortable: true,
    },

    {
      name: "Changed Completion On",
      selector: (row) => row?.changedCompletionOn,
      sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      sortable: true,
    },
  ];

  const handleRemarksChange = (e) => {
    setformData({ ...formData, remarks: e.target.value });
  };
  return (
    <div>
      {currentStats === "pending for approval" && !taskCompletedOn ? (
        <Tooltip title="Approved Task">
          <IconButton
            color="primary"
            onClick={() => handleClickOpen(row.original)}
          >
            <TaskIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="">
          <IconButton color="error">
            <NotInterestedIcon />
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        fullScreen
        onClose={handleClose}
        open={open}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          })}
        >
          <MDTypography>Task Details: {taskName} : #{Id}</MDTypography>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "relative",
              top: "-8px",
            }}
          >
            <CloseIcon color="error" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          fullScreen
        >
          <DataTable
            columns={header}
            data={ViewData}
            canSearch
            responsive
            pagination
            striped
            paginationPerPage={20}
            paginationRowsPerPageOptions={[5, 10, 20]}
            theme={
              darkModeContext[0].darkMode ? "modifiedDarkTheme" : "default"
            }
            fixedHeader
            persistTableHead
            fixedHeaderScrollHeight={`${(window.innerHeight / 100) * 66}px`}
          />
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={2}
          >
            {currentStats === "pending for approval" ? (
              <Tooltip title="Approval Task">
                <Button
                  onClick={() => onUpdateStatus(row.original)}
                  sx={{
                    backgroundColor: "#F44335",
                    "&:hover": {
                      backgroundColor: "#F44335",
                    },
                  }}
                  variant="contained"
                >
                  Approved Task
                </Button>
              </Tooltip>
            ) : (
              <IconButton color="error">
                <NotInterestedIcon />
              </IconButton>
            )}

            {currentStats === "" ? (
              <IconButton color="error" variant="contained">
                <NotInterestedIcon />
              </IconButton>
            ) : (
              <Tooltip title="Task ReOpen">
                <Button
                  onClick={() => handleOpenTask()}
                  color="primary"
                  variant="contained"
                >
                  Re-Open Task
                </Button>
              </Tooltip>
            )}
          </MDBox>
        </DialogContent>
      </Dialog>

      <Dialog
        onClose={handleClosedTask}
        open={openTask}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          })}
        >
          Remarks
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDBox sx={{ width: 400 }}>
            <MDInput
              rows={8}
              multiline
              fullWidth
              onChange={handleRemarksChange}
              value={formData.remarks}
              placeholder="Please Enter The Remarks..."
            />
          </MDBox>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleClosedTask} color="secondary">
            Cancel
          </MDButton>
          <MDButton
            color="success"
            autoFocus
            onClick={onReOpenTask}
            type="submit"
          >
            Apply
          </MDButton>
        </DialogActions>
      </Dialog>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </div>
  );
}
